import { calculatePaginationOffset, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
export const malwareApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getMalware: build.query({
            // matchFulfilled only fires on real fetches, not cache hits. Without keepUnusedDataFor=0,
            // extraReducer matchers (e.g. auto-expand on single-match filters) silently
            // skip on re-navigation because RTK Query serves cached data instead of fetching.
            keepUnusedDataFor: 0,
            query: (queryArg) => ({
                url: `${REPORTS_ENDPOINT}/${queryArg.ui_id}/malware`,
                params: {
                    hide_triaged: queryArg.filter.hide_triaged,
                    threat_name: queryArg.filter.threat_name,
                    threat_type: queryArg.filter.threat_type,
                    limit: queryArg.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(queryArg.pagination),
                    sort_by: convertSortToQueryString(queryArg.sort),
                },
            }),
        }),
        getThreatTypes: build.query({
            query: (queryArg) => ({
                url: `${REPORTS_ENDPOINT}/${queryArg.ui_id}/malware/threat-types`,
            }),
        }),
        getThreatTypeDetails: build.query({
            query: (queryArg) => ({
                url: `${REPORTS_ENDPOINT}/${queryArg.ui_id}/malware/${queryArg.ui_item_id}/details`,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetMalwareQuery, useLazyGetThreatTypesQuery, useGetThreatTypeDetailsQuery, } = malwareApi;
//# sourceMappingURL=malware.api.js.map